import {WFSLayerInfosService} from '../../core/services'

export class AppWFSLayerInfosService extends WFSLayerInfosService {}
